/**
 * @param {Record<string,string>} assets
 */
function loadAssets(assets) {
	assets["favicon-16x16.png"] = new URL(
		"../assets/patura/favicon-16x16.png",
		import.meta.url,
	).href;
	assets["favicon-32x32.png"] = new URL(
		"../assets/patura/favicon-32x32.png",
		import.meta.url,
	).href;
	assets["fencealarm.png"] = new URL(
		"../assets/patura/fencealarm.png",
		import.meta.url,
	).href;
	assets["fencealarm2.png"] = new URL(
		"../assets/patura/fencealarm2.png",
		import.meta.url,
	).href;
	assets["logo.png"] = new URL(
		"../assets/patura/logo.png",
		import.meta.url,
	).href;
	assets["smartplug.png"] = new URL(
		"../assets/patura/smartplug.png",
		import.meta.url,
	).href;
	assets["smartplug2.png"] = new URL(
		"../assets/patura/smartplug2.png",
		import.meta.url,
	).href;
}

/**
 * @param {Record<string,string>} assets
 * @param {import("./common").Config} config
 */
export function loadPaturaAppEnv(assets, config) {
	loadAssets(assets);
	populateConfig(config);
	import(`../css/patura/style.css`);
}

/**
 * @param {import("./common").Config} config
 */
function populateConfig(config) {
	config.apiBaseUrl = "https://api.luda.farm";
	config.apiHost = "api.luda.farm";
	config.appId = "patura.luda.farm";
	config.baseUrl = "https://patura.luda.farm";
	config.brand = "patura";
	config.navbarTheme = "is-light";
	config.sp2gwHost = "smartplug2.luda.farm";
	config.stripeBaseUrl = "https://dashboard.stripe.com";
	config.supportedDevices = [
		"fencealarm2",
		"fencealarm",
		"smartplug2",
		"smartplug",
	];
}
